import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";
import { useAuth } from "../../../components/context/LoginContext/AuthContext";

/**
 * Custom hook to mark an announcement as read by notification ID
 */
export const useMarkAnnouncementAsRead = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const { axiosInstance } = useAxios();
  const { fetchWithAuth } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  /**
   * Mark an announcement as read
   * @async
   * @param {number} notificationId - The notification ID to mark as read
   * @param {() => void} [onSuccess] - Optional callback on success
   * @returns {Promise<boolean>} Resolves with true on success, false on failure
   */
  const markAsRead = async (notificationId, onSuccess, {type}) => {
    try {
      setLoading(true);
      setError("");
      setSuccess(false);


      const domain = type === "pcnormal" ? apiUrl : TENANT_DOMAIN;
      const url = `${domain}/notification/${notificationId}/read`;

      if (type === "pcnormal") {
        const raw = await fetchWithAuth(url, { method: "POST" });
        const parsed = await raw.json();
        setSuccess(true);
        return parsed?.data || null;
      }

      await axiosInstance.post(url);

      setSuccess(true);
      if (onSuccess) onSuccess();
      return true;
    } catch (err) {
      setSuccess(false);
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    success,
    markAsRead,
  };
};
